import { ApiRequestFilters } from '../../../shared/types/api-request-filters';
import { AccountStatusEnum } from '../enums/account-status.enum';
import { AccountTypeEnum } from '../enums/account-type.enum';

/**
 * Account filters
 */
export class AccountsFilters extends ApiRequestFilters {
	/**
	 * Countries id values
	 */
	countries?: number[];

	/**
	 * Status values
	 */
	statuses?: AccountStatusEnum[];

	/**
	 * Record type values
	 */
	types?: AccountTypeEnum[];

	/**
	 * Exact handle. Stored form is matched after normalisation.
	 */
	handle?: string;

	/**
	 * QR payload. This slice has no share-code rows, so a QR code matches nothing.
	 */
	handleQrCode?: string;
}
